import axios from "axios";
import { getSessionId, captureAttribution, getAttribution, isInternalSession } from "./tracking";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export async function getMeta() {
  const { data } = await client.get("/meta");
  return data;
}

export async function getBrands() {
  const { data } = await client.get("/brands");
  return data;
}

export async function getCategories() {
  const { data } = await client.get("/categories");
  return data;
}

export async function getSectionMedia() {
  const { data } = await client.get("/section-media");
  return data;
}

export async function getFooter() {
  const { data } = await client.get("/footer");
  return data;
}

export async function trackVisit(path) {
  try {
    captureAttribution();
    const sid = getSessionId();
    const { ultimo } = getAttribution();
    const u = ultimo || {};
    await client.post("/track", {
      path: path || window.location.pathname,
      referrer: document.referrer || "",
      session_id: sid,
      utm_source: u.utm_source || null,
      utm_medium: u.utm_medium || null,
      utm_campaign: u.utm_campaign || null,
      utm_content: u.utm_content || null,
      utm_term: u.utm_term || null,
      fbclid_present: !!u.fbclid_present,
      landing_page: u.landing_page || null,
      referrer_domain: u.referrer_domain || null,
      is_internal: isInternalSession(),
    });
  } catch {
    /* il tracking non deve mai rompere la UI */
  }
}

export async function getProducts(params = {}) {
  const { data } = await client.get("/products", { params });
  return data;
}

export async function getProduct(slug) {
  const { data } = await client.get(`/products/${slug}`);
  return data;
}

export async function createOrder(payload) {
  const { data } = await client.post("/orders", payload);
  return data;
}

export async function getOrder(orderNumber) {
  const { data } = await client.get(`/orders/${orderNumber}`);
  return data;
}

export async function createOrderCheckout(orderNumber) {
  const { data } = await client.post(`/orders/${orderNumber}/checkout`);
  return data;
}

export async function recheckOrder(orderNumber) {
  const { data } = await client.post(`/orders/${orderNumber}/recheck`);
  return data;
}

export async function createTradeIn(payload) {
  const { data } = await client.post("/tradein", payload);
  return data;
}

export async function getHomepage() {
  const { data } = await client.get("/homepage");
  return data;
}

export async function getHomepagePreview() {
  // bozza homepage: richiede sessione admin (cookie)
  const { data } = await axios.get(`${API}/admin/homepage`, { withCredentials: true });
  return data;
}

export async function getOffers() {
  const { data } = await client.get("/offers");
  return data;
}

export async function getProductReviews(productId) {
  const { data } = await client.get(`/reviews/product/${productId}`);
  return data;
}

export async function getFeaturedReviews() {
  const { data } = await client.get("/reviews/featured");
  return data;
}

export async function getReviewsPolicy() {
  const { data } = await client.get("/reviews-policy");
  return data;
}

export default client;
